/*
 * @version: V1.0.0
 * @Date: 2023-10-30 09:15:06
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-03 17:53:11
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\restocking\index.js
 * @Descripttion:
 */
import request from '@/utils/request'
// 获取重入库记录
export function getRestockinList(params) {
  return request({
    url: '/wms/againInStock/list',
    method: 'get',
    params
  })
}


// 获取重入库记录统计
export function getRestockinStatistic() {
  return request({
    url: '/wms/againInStock/statistic',
    method: 'get'
  })
}
